import { ReactNode } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

const RaffleTicket = ({ children }: { children: ReactNode }) => {
  return (
    <div className="raffleTicket">
      <img
        src={`${ASSET_PREFIX}/images/token-town/sz-raffle-ticket.svg`}
        alt=""
      />

      <div className="childrenContainer flexCentered">{children}</div>

      <style jsx>
        {`
          .raffleTicket {
            position: relative;
            width: 180px;
            height: 67.5px;
          }

          .raffleTicket img {
            height: 100%;
            width: 100%;
          }

          .childrenContainer {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 25%;
            right: 5%;
            font-family: 'Press Start 2P', 'Montserrat', sans-serif !important;
            font-size: 1.1em;
          }
        `}
      </style>
    </div>
  );
};

export default RaffleTicket;
